var _rect, _path, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarretDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_24x24-ChevronDown",
    "data-name": "24x24-ChevronDown",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame24",
    width: 24,
    height: 24,
    fill: "#5a7087",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M7.912,8.747a.9.9,0,1,0-1.34,1.206l4.8,5.3a.9.9,0,0,0,1.342,0L17.43,10a.9.9,0,0,0-1.344-1.2l-3.754,4.18a.4.4,0,0,1-.594,0L7.912,8.747Z",
    transform: "translate(0.01)",
    fill: "#5a7087"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    media: "screen"
  }, "path{vector-effect:non-scaling-stroke}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretDown);
export default __webpack_public_path__ + "static/media/carret-down.f1978c82698cd1c08cd3cbc1294e7a76.svg";
export { ForwardRef as ReactComponent };